var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"camerite-header"},[(_vm.mobileView === false)?_c('WebHeader',{attrs:{"routes":this.routes}}):_vm._e(),(_vm.mobileView === true)?_c('MobileHeader',{attrs:{"routes":this.routes}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }